import React, {Component} from 'react';

import LoginHeader from './LoginHeader'
import Footer from './Footer'
class BaseLogin extends Component {

    componentWillMount() {

    }

    render() {
        return (
            <div>

                {/*<div className="page-loader startLoad">
                    <div className="loader startLoad"></div>
                </div>*/}

                <div id="wrap">
                    <LoginHeader/>

                    { this.props.children }

                    <Footer />
                    <div id="mask"></div>
                </div>
            </div>
        );
    }

}

export default BaseLogin
